import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll} from "@nosto/preact"
import { useEffect } from 'preact/hooks'

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import CategoryToolbar from "./CategoryToolbar";
import CategorySidebar from "./CategorySidebar";
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0

    let isMobile = window.innerWidth < 769; 

    useEffect(() => {
        nostojs(api => {
            api.createRecommendationRequest({
            includeTagging: true
            })
            .setElements(["searchpage-nosto-1"])
            .loadRecommendations()
        })
    },[foundProducts])

    return (
        <>
            {/* <div class="nosto_element" id="searchpage-nosto-1"></div> */}
            <div
                class="ns-serp ns-category ns-d-flex ns-flex-column ns-font-inherit"
                style="margin: auto; "
                data-nosto-element="search"
            >
                {foundProducts && (
                    <>
                    <CategorySidebar />
                    <CategoryToolbar mobile />
                    </>
                )}
                <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0">
                    {foundProducts ? (
                    <>
                        <CategoryToolbar />
                        <Products />
                        <BottomToolbar />
                    </>
                    ) : loading ? (
                        <Loader />
                    ) : (
                        <NoResults />
                    )}
                </div>
            </div>
        </>
    )
}
